module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject-view has-header"
  }, [_c('banner', {
    attrs: {
      "title": "聊聊你的观影感受"
    }
  }), _vm._v(" "), (!_vm.showLoading) ? [_c('div', {
    staticClass: "subject-card"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.subject.title))]), _vm._v(" "), _c('div', {
    staticClass: "subject-info"
  }, [_c('div', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [(_vm.subject.images) ? _c('img', {
    attrs: {
      "src": _vm.subject.images.large,
      "alt": "cover"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.subject.rating) ? _c('div', {
    staticClass: "left"
  }, [_c('rating', {
    attrs: {
      "rating": _vm.subject.rating
    }
  }, [_c('span', {
    slot: "ratingsCount"
  }, [_vm._v(_vm._s(_vm.subject.ratings_count) + "人评价")])]), _vm._v(" "), (_vm.subject.genres && _vm.subjectMeta) ? [_c('p', {
    staticClass: "meta"
  }, [_vm._v(_vm._s(_vm.subjectMeta))]), _vm._v(" "), _c('a', {
    staticClass: "open-app",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("用App查看影人资料")])] : _vm._e(), _vm._v(" "), (_vm.subject.author && _vm.subjectMeta) ? [_c('p', {
    staticClass: "meta"
  }, [_vm._v(_vm._s(_vm.subjectMeta))]), _vm._v(" "), _c('a', {
    staticClass: "buy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("在豆瓣购买")])] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (_vm.subject.author) ? _c('div', {
    staticClass: "vendors-link"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('marking', [(_vm.subject.author) ? _c('template', {
    slot: "book"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      }
    }
  }, [_vm._v("想读")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      }
    }
  }, [_vm._v("在读")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      }
    }
  }, [_vm._v("读过")])], 1) : _c('template', {
    slot: "movie"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      }
    }
  }, [_vm._v("想看")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'LoginView'
      }
    }
  }, [_vm._v("看过")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "subject-intro"
  }, [_c('h2', [_vm._v(_vm._s(_vm.subject.title) + "的简介")]), _vm._v(" "), _c('p', [(_vm.summary && _vm.subject.summary) ? [_vm._v("\n            " + _vm._s(_vm.isExpand ? _vm.summary : _vm.subject.summary) + "……\n          ")] : _vm._e(), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExpand),
      expression: "isExpand"
    }],
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.expand
    }
  }, [_vm._v("\n            (展开)\n          ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "genres"
  }, [_c('h2', [_vm._v("查看更多相关分类")]), _vm._v(" "), (_vm.genres) ? [_c('tags', {
    attrs: {
      "items": _vm.genres
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "subject-pics"
  }, [_c('h2', [_vm._v(_vm._s(_vm.subject.title) + "的图片")]), _vm._v(" "), (_vm.subject.images) ? _c('ul', [_c('li', {
    staticClass: "pic"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.subject.images.large,
      "alt": "poster"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "pic"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.subject.images.large,
      "alt": "poster"
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "pic"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.subject.images.large,
      "alt": "poster"
    }
  })])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "subject-comments"
  }, [_c('h2', [_vm._v(_vm._s(_vm.subject.title) + "的短评")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, [_vm._l((_vm.items), function(item) {
    return _c('card', {
      key: item,
      attrs: {
        "mold": "comment"
      }
    })
  }), _vm._v(" "), _c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("显示更多评论")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ad"
  }, [_c('banner', {
    attrs: {
      "adImg": _vm.adImgUrl
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "subject-question"
  }, [_c('h2', [_vm._v("关于" + _vm._s(_vm.subject.title) + "的问答")]), _vm._v(" "), _c('list', {
    attrs: {
      "items": _vm.questions
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("显示更多问答")])], 1), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "推荐的豆列",
      "type": "onlyString",
      "items": _vm.movieTags
    }
  }), _vm._v(" "), _c('download-app')] : _vm._e(), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }]
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "link"
  }, [_vm._v("\n          在哪儿买这本书？\n          "), _c('span', {
    staticClass: "info"
  }, [_vm._v("\n            豆瓣阅读电子书 66.00元起\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d66956e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SubjectView.vue
// module id = 200
// module chunks = 0